export const ADD_COMMENT = 'ADD_COMMENT';
export const SITES_LOADING = 'SITES_LOADING';
export const SITES_FAILED = 'SITES_FAILED';
export const ADD_SITES = 'ADD_SITES';

